export enum LearningTypes {
	Resource = 'Resource',
	ResourceValue = 1,
	Course = 'Course',
	CourseValue = 0,
}
